import callAPI from "../callApi";
import path from "../variables";

const Business = {
	// Investor Dashboard
	profitAndLoss: (startDate: string, endDate: string, stationId?: number) =>
		callAPI("GET", `${path.base}/business/profit-and-loss?start_date=${startDate}&end_date=${endDate}${stationId ? '&station_id=' + stationId : ''}`, "", "getting P&L report"),
	profitByRoute: (startDate: string, endDate: string) =>
		callAPI("GET", `${path.base}/business/profit-by-route?start_date=${startDate}&end_date=${endDate}`, "", "getting route profitability"),
	profitByStation: (startDate: string, endDate: string) =>
		callAPI("GET", `${path.base}/business/profit-by-station?start_date=${startDate}&end_date=${endDate}`, "", "getting station profitability"),
	profitByVehicle: (startDate: string, endDate: string) =>
		callAPI("GET", `${path.base}/business/profit-by-vehicle?start_date=${startDate}&end_date=${endDate}`, "", "getting vehicle profitability"),
	cashFlowProjection: (days?: number) =>
		callAPI("GET", `${path.base}/business/cash-flow-projection${days ? '?days=' + days : ''}`, "", "getting cash flow projection"),

	// Tax Dashboard
	calculateTaxes: (startDate: string, endDate: string) =>
		callAPI("GET", `${path.base}/business/taxes/calculate?start_date=${startDate}&end_date=${endDate}`, "", "calculating taxes"),
	getTaxRates: () =>
		callAPI("GET", `${path.base}/business/taxes/rates`, "", "getting tax rates"),
	updateTaxRates: (data: any) =>
		callAPI("PUT", `${path.base}/business/taxes/rates`, data, "updating tax rates"),

	// KPI Dashboard
	occupancyRate: (startDate: string, endDate: string, stationId?: number) =>
		callAPI("GET", `${path.base}/business/kpi/occupancy-rate?start_date=${startDate}&end_date=${endDate}${stationId ? '&station_id=' + stationId : ''}`, "", "getting occupancy rate"),
	fuelEfficiency: (startDate: string, endDate: string) =>
		callAPI("GET", `${path.base}/business/kpi/fuel-efficiency?start_date=${startDate}&end_date=${endDate}`, "", "getting fuel efficiency"),
	cashierProductivity: (startDate: string, endDate: string, stationId?: number) =>
		callAPI("GET", `${path.base}/business/kpi/cashier-productivity?start_date=${startDate}&end_date=${endDate}${stationId ? '&station_id=' + stationId : ''}`, "", "getting cashier productivity"),
	driverPerformance: (startDate: string, endDate: string) =>
		callAPI("GET", `${path.base}/business/kpi/driver-performance?start_date=${startDate}&end_date=${endDate}`, "", "getting driver performance"),
	alerts: () =>
		callAPI("GET", `${path.base}/business/kpi/alerts`, "", "getting business alerts"),
	refundsImpact: (startDate: string, endDate: string, stationId?: number) =>
		callAPI(
			"GET",
			`${path.base}/business/kpi/refunds-impact?start_date=${startDate}&end_date=${endDate}${stationId ? '&station_id=' + stationId : ''}`,
			"",
			"getting refunds impact KPI"
		),
};

export default Business;
